import { render, staticRenderFns } from "./MediaIframe.vue?vue&type=template&id=d46361c4&scoped=true&"
import script from "./MediaIframe.vue?vue&type=script&lang=js&"
export * from "./MediaIframe.vue?vue&type=script&lang=js&"
import style0 from "./MediaIframe.vue?vue&type=style&index=0&id=d46361c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46361c4",
  null
  
)

export default component.exports